import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  LoadUserSearchResults,
  SetUserSearchResults,
  SetUserSearchError,
} from './user-search.actions';
import { UserSearchService } from './user-search.service';
import { AdminOrganizationUser } from 'src/app/admin/models/organization.model';
import { UserSearchApiError, UserSearchApiErrorTypes } from './user-search.errors';

@Injectable()
export class UserSearchEffects {
  loadUserSearchResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadUserSearchResults),
      mergeMap(({ email }) =>
        this.userSearchService.loadUsersByEmail(email).pipe(
          map((user: AdminOrganizationUser) => SetUserSearchResults({ user })),
          catchError((err) => {
            if (err.status === 400) {
              return of(
                SetUserSearchError({
                  error: new UserSearchApiError(UserSearchApiErrorTypes.BadRequestError, err),
                }),
              );
            } else if (err.status === 404) {
              return of(
                SetUserSearchError({
                  error: new UserSearchApiError(UserSearchApiErrorTypes.NotFoundError, err),
                }),
              );
            }
            return of(
              SetUserSearchError({
                error: new UserSearchApiError(UserSearchApiErrorTypes.ServiceUnavailableError, err),
              }),
            );
          }),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private userSearchService: UserSearchService) {}
}
